import { STORE_REPLACE_PINWHEEL_SURVEY_QUESTIONS } from '@perpay-web/fintech/constants/actionTypes';

export function replacePinwheelSurveyQuestions(payload) {
    return {
        type: STORE_REPLACE_PINWHEEL_SURVEY_QUESTIONS,
        payload,
    };
}
